import { Link } from 'react-router-dom';
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Divider,
  Grid,
  Typography,
} from '@mui/material';
import {
  DescriptionOutlined,
  InfoOutlined,
  InsertDriveFileOutlined,
  PhotoAlbum,
} from '@mui/icons-material';
import { ContentPageResponse } from 'src/shared/services/api/response/contentPageResponse';

type ChildItemsGridProps = {
  childItems: ContentPageResponse[];
};

const getIcon = (type: string) => {
  if (type === 'DocumentListPage') return <DescriptionOutlined />;
  if (type === 'GalleryListPage') return <PhotoAlbum />;
  if (type === 'GalleryPage') return <PhotoAlbum />;
  if (type === 'MenuPage') return <InsertDriveFileOutlined />;
  return <InfoOutlined />;
};

const cleanContent = (html: string): string => {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = html;
  return textarea.value;
};

export const ChildItemsGrid = ({ childItems }: ChildItemsGridProps) => (
  <>
    <Divider />
    <Box my={2}>
      <Grid container spacing={2}>
        {childItems.map((childItem: ContentPageResponse) => (
          <Grid item xs={12} sm={6} md={4} key={childItem.id}>
            <Card
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                transition: 'all 0.3s ease',
                '&:hover': {
                  boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                  transform: 'translateY(-4px)',
                },
              }}
            >
              <CardActionArea
                component={Link}
                to={`/${childItem.contentType}/${childItem.id}`}
                sx={{
                  flexGrow: 1,
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <CardContent sx={{ flexGrow: 1, width: '100%' }}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: 1,
                      mb: 1,
                    }}
                  >
                    <Box
                      sx={{
                        color: 'primary.main',
                        display: 'flex',
                        flexShrink: 0,
                      }}
                    >
                      {getIcon(childItem.contentType)}
                    </Box>
                    <Typography
                      gutterBottom
                      variant='body2'
                      component='h3'
                      sx={{
                        color: 'primary.main',
                        mb: 0,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                      }}
                    >
                      {childItem.title ?? 'Untitled'}
                    </Typography>
                  </Box>
                  {childItem.content && (
                    <Typography
                      variant='subtitle1'
                      sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                      }}
                    >
                      {cleanContent(childItem.content.replace(/<[^>]*>/g, ''))}
                    </Typography>
                  )}
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  </>
);
